import { useTranslation } from 'react-i18next';

import { SummaryInformation, TSummaryInformation } from '@/ui-kit/SummaryInformation/SummaryInformation';

import { TSelfSectionKey } from '@/features/kyc/store/types/self.types';
import { KycInformationSection } from '@/features/kyc/components/userInformation/InformationSection';

import { useSelfEmployedVerificationProps } from '@/features/kyc/hooks/useSelfEmployedVerificationProps';
import { IUser } from '@/features/user/store/user.model';

import { TaxResidences } from '@/features/taxResidences/components/TaxResidences';

interface IVerificationDetail {
  user: IUser;
  isSectionOnEdition: (key: TSelfSectionKey) => boolean;
  isSectionEditable: (key: TSelfSectionKey) => boolean;
  toogleSectionEditMode: (key: TSelfSectionKey) => void;
}

export function SelfVerificationDetail({
  user,
  isSectionOnEdition,
  isSectionEditable,
  toogleSectionEditMode,
}: IVerificationDetail) {
  const { t } = useTranslation();

  const isBirthAndNationalityOnEdition = isSectionOnEdition('birthAndNationality');
  const isSituationOnEdition = isSectionOnEdition('situation');

  const { isBirthAndNationalityInvalid, birthNationality, situation, isLoading, onUpdateUser, onCancelEdition } =
    useSelfEmployedVerificationProps({
      user,
      isBirthAndNationalityOnEdition,
      isSituationOnEdition,
    });

  const userVerification: TSummaryInformation = {
    title: t('pages.dashboard.createUser.form.pages.verificationDetails'),
    sections: [
      {
        component: (
          <KycInformationSection
            section={birthNationality}
            isOnEdition={isBirthAndNationalityOnEdition}
            sectionKey="birth-nationality"
            isLoading={isLoading}
            isFormInvalid={isBirthAndNationalityInvalid}
            isSectionNotEditable={isSectionEditable('birthAndNationality')}
            onEdit={() => toogleSectionEditMode('birthAndNationality')}
            onSave={() => onUpdateUser(() => toogleSectionEditMode('birthAndNationality'))}
            onCancel={() => onCancelEdition(() => toogleSectionEditMode('birthAndNationality'))}
          />
        ),
      },
      {
        component: (
          <KycInformationSection
            section={situation}
            isOnEdition={isSituationOnEdition}
            sectionKey="situation"
            isLoading={isLoading}
            isSectionNotEditable={isSectionEditable('situation')}
            onEdit={() => toogleSectionEditMode('situation')}
            onSave={() => onUpdateUser(() => toogleSectionEditMode('situation'))}
            onCancel={() => onCancelEdition(() => toogleSectionEditMode('situation'))}
          />
        ),
      },
      {
        component: (
          <TaxResidences
            user={user}
            isSectionOnEdition={isSectionOnEdition('taxResidence')}
            isSectionEditable={isSectionEditable('taxResidence')}
            toogleSectionEditMode={() => toogleSectionEditMode('taxResidence')}
          />
        ),
      },
    ],
  };

  return <SummaryInformation {...userVerification} key="userVerification" />;
}
